// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="4" offset-sm="4">
        <v-card>
          <v-card-title>
            <span class="headline">Login</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
            label="Email"
            id="email"
            required
            v-model="credentials.username"
            v-on:keyup.enter="login()"
            ></v-text-field>
            <v-text-field
            label="Password"
            id="password"
            type="password"
            required
            v-model="credentials.password"
            v-on:keyup.enter="login()"
            ></v-text-field>
            <router-link :to="{name: 'passwordResetRequest'}">Forgot My Password</router-link>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue--text darken-1" text @click.native="login">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      errorText: ''
    }
  },

  methods: {
    ...mapActions([
      'getUserData'
    ]),

    login: function () {
      var credentials = {
        username: this.credentials.username,
        password: this.credentials.password
      }
      axios.post('/auth/login', credentials, {}).then(response => {
        var ref = this.$route.query.referer
        if (ref === undefined) {
          this.$router.push({name: 'images'})
          return
        }
        var split = ref.split('?')
        var path = ''
        if (split.length > 0) {
          path = split[0]
        }
        if (ref && path !== '' && !ref.includes('login')) {
          this.$router.push(ref)
        } else {
          this.$router.push({name: 'images'})
        }
        this.getUserData()
      }).catch(e => {
        if (e.response.data !== undefined && e.response.data.reason !== undefined) {
          if (e.response.data.reason === 'rate limited') {
            this.errorText = 'Too many recent failed logins: wait a minute and try again'
          } else if (e.response.data.reason === 'account locked') {
            this.errorText = 'Too many recent failed logins: use Forgot My Password to unlock your account'
          } else {
            this.errorText = 'Invalid username or password'
          }
        } else {
          this.errorText = 'Invalid username or password'
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?ca970d5c